<template>
    <div class="upload">
        <el-dialog title="上传物料" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
            <div class="form">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="right">
                    <el-form-item label="活动标题：" prop="title">
                        <el-input v-model="ruleForm.title" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间：" prop="date">
                        <el-date-picker
                            v-model="ruleForm.date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="expireTimeOption"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="活动说明：" prop="remake">
                        <el-input v-model="ruleForm.remake" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="活动图：" prop="file">
                        <el-upload
                            class="upload-demo"
                            list-type="picture-card"
                            ref="upload"
                            action="123"
                            multiple
                            :class="ruleForm.file.length == 5 ? 'mf' : ''"
                            style="width: 100%"
                            :auto-upload="false"
                            :file-list="ruleForm.file"
                            :limit="5"
                            :on-exceed="handleExceed"
                            :on-change="(file, fileList) => handleChange(file, fileList, 1)"
                            :on-remove="(file, fileList) => handleRemove(file, fileList, 1)"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        {{ ruleForm.file.length + "/5" }}
                    </el-form-item>
                    <el-form-item label="活动海报：" prop="poster">
                        <el-upload
                            action="#"
                            list-type="picture-card"
                            :auto-upload="false"
                            :file-list="ruleForm.poster"
                            :class="ruleForm.poster.length == 1 ? 'mf' : ''"
                            :on-change="(file, fileList) => handleChange(file, fileList, 2)"
                            :on-remove="(file, fileList) => handleRemove(file, fileList, 2)"
                        >
                            <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="postInfo" :loading="btnload">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="imgDialog" class="imgDialog">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            btnload: false,
            id: "",
            dialogVisible: false,
            ruleForm: {
                title: "",
                date: [],
                remake: "",
                poster: [],
                file: [],
                poster_url: [],
                file_url: [],
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入活动标题",
                        trigger: "blur",
                    },
                ],
                date: [
                    {
                        required: true,
                        message: "请输入活动时间",
                        trigger: "change",
                    },
                ],
                remake: [
                    {
                        required: true,
                        message: "请输入活动说明",
                        trigger: "blur",
                    },
                ],

                poster: [
                    {
                        required: true,
                        message: "请上传活动海报",
                        trigger: "change",
                    },
                ],
                file: [
                    {
                        required: true,
                        message: "请上传活动图",
                        trigger: "change",
                    },
                ],
            },
            dialogImageUrl: "",
            imgDialog: false,
            disabled: false,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            upInfo: "commodity/upInfo",
            uploadFile: "commodity/uploadFile",
        }),
        postInfo() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.btnload = true;
                    let opt = {
                        token: this.getToken,
                        title: this.ruleForm.title, //标题
                        activity_merchant_id: this.id, //需求id
                        start_time: this.ruleForm.date[0] ? this.ruleForm.date[0] : null, //开始时间
                        end_time: this.ruleForm.date[1] ? this.ruleForm.date[1] : null, //结束时间
                        rules: this.ruleForm.remake, //活动说明
                        carousel_image: this.ruleForm.file_url[0], //活动图
                        poster_image: this.ruleForm.poster_url[0], //海报图
                    };
                    this.upInfo(opt).then((res) => {
                        this.btnload = false;
                        if (res.code == 1) {
                            this.dialogVisible = false;
                            this.$message.success("上传成功！");
                            this.$emit("init");
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
            });
        },
        handleExceed(files, fileList) {
            this.$message.warning("只能上传5张图片，请先删除当前文件，再重新上传");
            return false;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.imgDialog = true;
        },
        handleClose() {
            this.$refs.ruleForm.resetFields();
            this.dialogVisible = false;
        },
        handleChange(file, fileList, index) {
            // console.log(file, fileList);
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            if (index == 1) {
                this.ruleForm.file = fileList;
            } else {
                this.ruleForm.poster = fileList;
            }
            this.uploadFile(formdata).then((res) => {
                if (res.code == 1) {
                    // console.log(res);
                    this.$message.success("上传成功！");
                    if (index == 1) {
                        this.ruleForm.file_url.push(res.data.formdata_details[0].urls);
                    } else {
                        this.ruleForm.poster_url.push(res.data.formdata_details[0].urls);
                    }
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        /*文件移除*/
        handleRemove(file, fileList, index) {
            if (index == 1) {
                this.ruleForm.file.map((item, index) => {
                    if (item.name == file.name) {
                        this.ruleForm.file.splice(index, 1);
                    }
                });
            } else {
                this.ruleForm.poster.map((item, index) => {
                    if (item.name == file.name) {
                        this.ruleForm.poster.splice(index, 1);
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.form {
    padding: 0 20px;
    height: 550px;
    overflow-y: auto;
}
.imgDialog {
    ::v-deep .el-dialog__header {
        bottom: none;
    }
}
.mf {
    ::v-deep .el-upload--picture-card {
        display: none !important;
    }
}
</style>